const appInfo = {
	title: "HCAO Integrator",
};
export default appInfo;
